export default "__VITE_ASSET__DsvUoS8E__"